export default __webpack_public_path__ + "static/media/tigerbox_touch_purple.9915d276.png";